/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
//set all global variables
var termURL;
var prop;
// var relURL = "/";
// var relURL = "/toyota/";
var relURL = 'https://toyotapartsandservicehub.com/';
(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages
        //Side Menu


        var o = document.getElementById('protect-overlay');

        if (sessionStorage.getItem('advertOnce') !== 'true') {

          o.style.display = "block";

          o.getElementsByTagName('form')[0].onsubmit = function () {

            var text = this.answer.value;
            // var text = $('#passHolder').val();
            var firstDigit = text.substring(0, 1);
            var passL = text.length;
            // alert(variable2);

            if (!isNaN(text)) {
              if (passL == 5) {
                console.log('password is 5 charactres');
                if (firstDigit < 7 && firstDigit >= 0 || firstDigit == 8) {
                  // if (firstDigit==8) {
                  o.style.display = "none";
                  console.log('first digit is between 0-6 AND password is 5 characters long');
                  sessionStorage.setItem('advertOnce', 'true');
                } else {
                  alert('Sorry, you have entered an invalid Toyota Dealer Code');
                  console.log('password is 5 charactres but first digit is NOT between 0-6');
                }
              } else {
                alert('Sorry, you have entered an invalid Toyota Dealer Code');
                console.log('password is NOT 5 charactres');
              }
            } else {
              alert('Sorry, you have entered an invalid Toyota Dealer Code');
            }

            return false;
          };

        } else {

          o.style.display = "none";

        }


        $('#reset-session').on('click', function () {
          sessionStorage.setItem('advertOnce', '');
        });


        $(".sendmail").click(function (e) {
          console.log($(this).data("tis"));
          $(".tis_number").val($(this).data("tis"));
          $(".resend-first").val($(this).data("first"));
          $(".resend-last").val($(this).data("last"));
        });


        var isLateralNavAnimating = false;
        //open/close lateral navigation
        $('.hamburger-menu').on('click', function () {
          $('.bar').toggleClass('animate');
          $('.mobilemenu').toggleClass('active');
          $('.menu-overlay').toggleClass('darken');
        });
        $('.menu-overlay').on('click', function () {
          $('.bar').removeClass('animate');
          $('.mobilemenu').removeClass('active');
          $(this).removeClass('darken');
        });
        //for tab hash change
        if (location.hash !== '') {
          $('.nav-tabs a[href="' + location.hash.replace('tab_', '') + '"]').tab('show');
        } else {
          $('.nav-tabs a:first').tab('show');
        }
        $('.nav-tabs a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
          window.location.hash = 'tab_' + e.target.hash.substr(1);
          return false;
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
        $('.slider-fade').slick({
          dots: false,
          infinite: true,
          speed: 500,
          fade: true,
          cssEase: 'linear'
        });

        $('.vimeo-modal').click(function (event) {
          event.preventDefault();
          //console.log(termValue);
          $('#video_modal').modal();
          //grab the data id
          var video_id = $(this).data('id');
          // console.log(video_id);
          $('#video_modal .modal-content').css({
            display: 'inline-block'
          }).animate({
            "opacity": 1,
            'min-height': "350px"
          }, 'slow').html('<div class="rectangle-bounce"><img class="loader" src="http://samherbert.net/svg-loaders/svg-loaders/circles.svg" /></div>');
          var htmlData = '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' + '<div class="modal-body">';
          htmlData += '<div class="video_wrapper"><iframe id="player' + video_id + '" src="https://player.vimeo.com/video/' + video_id + '?api=1&player_id=player' + video_id + '&amp;autoplay=true" width="630" height="354" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>';
          htmlData += '</div>';
          $('#video_modal .modal-content').html(htmlData);
          $('#video_modal').on('hidden.bs.modal', function () {
            $(".modal-content").empty();
          });
        });
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'parent_pageid_118': {
      init: function () {


        $('.responsive').slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 6,
          slidesToScroll: 1,
          responsive: [{
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: false
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });


      }
    },


    'register': {
      init: function () {
        //console.log("form");

        $('.enroll-tab').click(function (e) {
          e.preventDefault();
          $('#enroll').tab('show');
        });

        //conact form
        $("#enroll-form").validator().on("submit", function (event) {
          if (event.isDefaultPrevented()) {
            // handle the invalid form...
            formError();
            submitMSG(false, "Did you fill in the form properly?");
          } else {
            // everything looks good!
            event.preventDefault();
            submitForm();
            //licenseAgreement();
          }
        });

        function licenseAgreement() {
          //show license-agreement
          $('.enroll-section').addClass("is_visible");
          //submitForm();
          $('.modal-action').click(function (event) {
            event.preventDefault();
            //console.log(termValue);
            $('#agree_modal').modal();
            modalAgreement();
          });
        }

        function modalAgreement() {
          $('.btn-action').click(function (event) {
            event.preventDefault();
            var agree = $(this).data('id');
            if (agree === "agree") {
              console.log(agree);
              submitForm();
            }
          });
        }

        $('input[name=program]').on("change", function () {
          /* Reset Check Boxes */
          console.log($('input[name=program]:checked').val());
          $('#agree1').prop('required', true);
          $('#agree2').prop('required', true);
          $('#agree3').prop('required', true);

          $('#agree1').prop('checked', false);
          $('#agree2').prop('checked', false);
          $('#agree3').prop('checked', false);


          $('#terms-elite').scrollTop(0);
          $('#terms-tmpp').scrollTop(0);
          $('#terms-ops').scrollTop(0);

          $(".programs-help-block").hide();


          if ($(this).val() == "starelite") {
            $('.starelite').show();
            $('.tmpp').hide();
            $('.ops').hide();
            $('#agree1').attr('disabled', 'disabled');
            $('#agree2').attr('disabled', 'disabled');
            $('#agree3').attr('disabled', 'disabled');
            $('#tmpp').prop('required', true);
            $('#psx').prop('required', true);
            $('#ops').prop('required', true);
            $('#wsip').prop('required', true);
          } else if ($(this).val() == "tmpp") {
            console.log($(this).val());
            $('.starelite').hide();
            $('.tmpp').show();
            $('.ops').hide();
            $('#agree1').attr('disabled', 'disabled');
            $('#agree2').attr('disabled', 'disabled');
            $('#agree3').attr('disabled', 'disabled');
            $('#tmpp').prop('required', false);
            $('#psx').prop('required', false);
            $('#ops').prop('required', false);
            $('#wsip').prop('required', false);
          } else if ($(this).val() == "ops") {
            $('.starelite').hide();
            $('.tmpp').hide();
            $('.ops').show();
            $('#tmpp').prop('required', false);
            $('#psx').prop('required', false);
            $('#ops').prop('required', false);
            $('#wsip').prop('required', false);

            $('#agree1').attr('disabled', 'disabled');
            $('#agree2').attr('disabled', 'disabled');
            $('#agree3').attr('disabled', 'disabled');
          }
        })

        $('#terms-elite').scroll(function () {

          diff = $(this)[0].scrollHeight - $(this).height();


          if ($(this).scrollTop() == $(this)[0].scrollHeight - $(this).height() - 24) {
            console.log("agree");
            $('#agree1').removeAttr('disabled');
            $('#agree2').prop('required', false);
            $('#agree3').prop('required', false);
          }
        });
        $('#terms-tmpp').scroll(function () {

          diff = $(this)[0].scrollHeight - $(this).height();


          if ($(this).scrollTop() == $(this)[0].scrollHeight - $(this).height() - 24) {
            console.log("agree");
            $('#agree1').prop('required', false);
            $('#agree2').removeAttr('disabled');
            $('#agree3').prop('required', false);
          }
        });
        $('#terms-ops').scroll(function () {

          diff = $(this)[0].scrollHeight - $(this).height();


          if ($(this).scrollTop() == $(this)[0].scrollHeight - $(this).height() - 24) {
            console.log("agree");
            $('#agree1').prop('required', false);
            $('#agree2').prop('required', false);
            $('#agree3').removeAttr('disabled');
          }
        });


        $("#psx").on("change", function () {
          if ($(this).val() == "psx" || $(this).val() == "psxadvanced") {


            $(".wsip").prop('disabled', false);
            var newOptions = {
              "SELECT ONE": "",
              "NO": "no",
              "YES": "yes"
            };

            var $el = $(".wsip");
            $el.empty(); // remove old options
            $.each(newOptions, function (key, value) {
              $el.append($("<option></option>")
                .attr("value", value).text(key));
            });

          } else {
            $(".wsip").prop('disabled', true);
            var option = $('<option></option>').attr("value", "option value").text("n/a");
            $(".wsip").empty().append(option);
          }
        })

        $('.dropdown-menu a').on('click', function () {
          $('.dropdown-toggle').html($(this).html() + '<span class="caret"></span>');
        })

        function submitForm() {
          // Initiate Variables With Form Content
          var date = $("#date").val();
          var code = $("#dealer_code").val();
          var dealership = $("#dealership").val();
          var url = $("#url").val();
          var address = $("#address").val();
          var city = $("#city").val();
          var state = $("#state").val();
          var zip = $("#zip").val();
          //var lang = $("#lang").val();
          //var zone = $("#zone").val();
          var name = $("#name").val();
          var lname = $("#lname").val();
          var title = $("#title").val();
          var phone = $("#phone").val();
          var email = $("#email").val();
          var wholesale_phone = $("#wholesale_phone").val();
          var toll_free = $("#toll_free").val();
          var fax = $("#fax").val();
          var tmpp = $("#tmpp").val();
          var psx = $("#psx").val();
          var ops = $("#ops").val();
          var wsip = $("#wsip").val();
          var agree1 = $("#agree1").val();
          var agree2 = $("#agree2").val();
          var agree3 = $("#agree3").val();
          var program_option = $('input[name=program]:checked').val();
          //var licenceadmin = (($('#licenceadmin').is(':checked')) ? "yes" : "no");
          //var pricingadmin = (($('#pricingadmin').is(':checked')) ? "yes" : "no");
          $.ajax({
            type: "POST",
            url: relURL + "toyota/wp-content/themes/toyotawholesale/lib/form-process2.php",
            data: "date=" + date + "&code=" + code + "&url=" + url + "&dealership=" + dealership + "&address=" + address + "&city=" + city + "&state=" + state + "&zip=" + zip + "&name=" + name + "&lname=" + lname + "&title=" + title + "&phone=" + phone + "&email=" + email + "&wholesale_phone=" + wholesale_phone + "&toll_free=" + toll_free + "&fax=" + fax + "&tmpp=" + tmpp + "&psx=" + psx + "&ops=" + ops + "&wsip=" + wsip + "&agree1=" + agree1 + "&agree2=" + agree2 + "&agree3=" + agree3 + "&program_option=" + program_option,
            success: function (text) {
              formSuccess();
              console.log(text);
            }
          });
        }

        function formSuccess() {
          $('.enroll-section').addClass("is_visible");
          $('#agree_modal').modal();
          $(".enroll-form").addClass('sent');
          $("#enroll-form")[0].reset();
          $(".modal-content").addClass('sent');
          $('.enroll-section').removeClass("is_visible");
          $(".modal-content").html("<h3>Congratulations! You’ve completed enrollment in the 2019 STAR Elite program. If additional action is required, the STAR Elite Admin or supplier partner will reach out to you within three business days.</h3>");
          submitMSG(true, "");
        }

        function formError() {
          console.log($('input[name=program]:checked').val());
          if ($('input[name=program]:checked').val() == undefined) {
            $(".programs-help-block").show();
          } else {
            $(".programs-help-block").hide();
          }

          $("#enroll-form").removeClass().addClass('enroll-form shake animated').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
            $(this).removeClass();
          });
        }

        function submitMSG(valid, msg) {
          if (valid) {
            var msgClasses = "text-left animated text-success";
            $("#form-submit").text("SENT");
          } else {
            var msgClasses = "text-left text-danger";
          }
          $("#msgSubmit").removeClass().addClass(msgClasses).text(msg);
        }
      }
    },


    // 'page_template_template_join_v2': {

    'page_template_template_join_v2': {
      init: function () {

        window.onload = function () {
          if (typeof history.pushState === "function") {

            $('input[name=program]').attr('checked', false);

          } else {


          }
        }


        $('.enroll-btn').click(function (e) {
          $('.modal').modal('hide');
          setTimeout(function () {
            $('a[href="#enroll"]').tab('show');
          }, 200);
        });

        function change() {
          var src = document.getElementById("user_email_new");
          var dest = document.getElementById("user_email");
          var dest_user = document.getElementById("user_login");
          dest.value = src.value;
          dest_user.value = src.value;
        }

        $("#user_email_new").keyup(function () {
          change();
        });


        $('.enroll-tab').click(function (e) {
          e.preventDefault();
          $('#enroll').tab('show');
        });

        //conact form
        $("#enroll-form").validator().on("submit", function (event) {
          if (event.isDefaultPrevented()) {
            // handle the invalid form...
            formError();
            submitMSG(false, "Did you fill in the form properly?");
          } else {
            // everything looks good!
            event.preventDefault();
            submitForm();
            //licenseAgreement();
          }
        });

        function licenseAgreement() {
          //show license-agreement
          $('.enroll-section').addClass("is_visible");
          //submitForm();
          $('.modal-action').click(function (event) {
            event.preventDefault();
            //console.log(termValue);
            $('#agree_modal').modal();
            modalAgreement();
          });
        }

        function modalAgreement() {
          $('.btn-action').click(function (event) {
            event.preventDefault();
            var agree = $(this).data('id');
            if (agree === "agree") {
              console.log(agree);
              //  submitForm();
            }
          });
        }

        $('input[name=program]').on("change", function () {
          /* Reset Check Boxes */
          console.log($('input[name=program]:checked').val());
          $('#agree1').prop('required', true);
          $('#agree2').prop('required', true);
          $('#agree3').prop('required', true);

          $('#agree1').prop('checked', false);
          $('#agree2').prop('checked', false);
          $('#agree3').prop('checked', false);


          $('#terms-elite').scrollTop(0);
          $('#terms-tmpp').scrollTop(0);
          $('#terms-ops').scrollTop(0);

          $(".programs-help-block").hide();


          if ($(this).val() == "starelite") {
            $('.starelite').show();
            $('.tmpp').hide();
            $('.ops').hide();
            $('#agree1').attr('disabled', 'disabled');
            $('#agree2').attr('disabled', 'disabled');
            $('#agree3').attr('disabled', 'disabled');
            $('#tmpp').prop('required', true);
            $('#psx').prop('required', true);
            $('#ops').prop('required', true);
            $('#wsip').prop('required', true);
          } else if ($(this).val() == "tmpp") {
            console.log($(this).val());
            $('.starelite').hide();
            $('.tmpp').show();
            $('.ops').hide();
            $('#agree1').attr('disabled', 'disabled');
            $('#agree2').attr('disabled', 'disabled');
            $('#agree3').attr('disabled', 'disabled');
            $('#tmpp').prop('required', false);
            $('#psx').prop('required', false);
            $('#ops').prop('required', false);
            $('#wsip').prop('required', false);
          } else if ($(this).val() == "ops") {
            $('.starelite').hide();
            $('.tmpp').hide();
            $('.ops').show();
            $('#tmpp').prop('required', false);
            $('#psx').prop('required', false);
            $('#ops').prop('required', false);
            $('#wsip').prop('required', false);

            $('#agree1').attr('disabled', 'disabled');
            $('#agree2').attr('disabled', 'disabled');
            $('#agree3').attr('disabled', 'disabled');
          }
        })

        $('#terms-elite').scroll(function () {

          diff = $(this)[0].scrollHeight - $(this).height();


          if ($(this).scrollTop() == $(this)[0].scrollHeight - $(this).height() - 24) {
            console.log("agree");
            $('#agree1').removeAttr('disabled');
            $('#agree2').prop('required', false);
            $('#agree3').prop('required', false);
          }
        });
        $('#terms-tmpp').scroll(function () {

          diff = $(this)[0].scrollHeight - $(this).height();


          if ($(this).scrollTop() == $(this)[0].scrollHeight - $(this).height() - 24) {
            console.log("agree");
            $('#agree1').prop('required', false);
            $('#agree2').removeAttr('disabled');
            $('#agree3').prop('required', false);
          }
        });
        $('#terms-ops').scroll(function () {

          diff = $(this)[0].scrollHeight - $(this).height();


          if ($(this).scrollTop() == $(this)[0].scrollHeight - $(this).height() - 24) {
            console.log("agree");
            $('#agree1').prop('required', false);
            $('#agree2').prop('required', false);
            $('#agree3').removeAttr('disabled');
          }
        });


        $("#psx").on("change", function () {
          if ($(this).val() == "psx" || $(this).val() == "psxadvanced") {
            $(".wsip").prop('disabled', false);
            var newOptions = {
              "SELECT ONE": "",
              "NO": "no",
              "YES": "yes"
            };

            var $el = $(".wsip");
            $el.empty(); // remove old options
            $.each(newOptions, function (key, value) {
              $el.append($("<option></option>")
                .attr("value", value).text(key));
            });

          } else {
            $(".wsip").prop('disabled', true);
            var option = $('<option></option>').attr("value", "option value").text("n/a");
            $(".wsip").empty().append(option);
          }
        })

        $('.dropdown-menu a').on('click', function () {
          $('.dropdown-toggle').html($(this).html() + '<span class="caret"></span>');
        })

        function submitForm() {
          // Initiate Variables With Form Content
          var date = $("#date").val();
          var code = $("#dealer_code").val();
          var dealership = $("#dealership").val();
          var url = $("#url").val();
          var address = $("#address").val();
          var city = $("#city").val();
          var state = $("#state").val();
          var zip = $("#zip").val();
          //var lang = $("#lang").val();
          //var zone = $("#zone").val();
          var name = $("#name").val();
          var lname = $("#lname").val();
          var title = $("#title").val();
          var phone = $("#phone").val();
          var email = $("#email").val();
          var wholesale_phone = $("#wholesale_phone").val();
          var toll_free = $("#toll_free").val();
          var fax = $("#fax").val();
          var tmpp = $("#tmpp").val();
          var psx = $("#psx").val();
          var ops = $("#ops").val();
          var wsip = $("#wsip").val();
          var agree1 = $("#agree1").val();
          var agree2 = $("#agree2").val();
          var agree3 = $("#agree3").val();
          var program_option = $('input[name=program]:checked').val();
          //var licenceadmin = (($('#licenceadmin').is(':checked')) ? "yes" : "no");
          //var pricingadmin = (($('#pricingadmin').is(':checked')) ? "yes" : "no");
          $.ajax({
            type: "POST",
            url: relURL + "toyota2019/wp-content/themes/toyotawholesale/lib/form-process2.php",
            data: "date=" + date + "&code=" + code + "&url=" + url + "&dealership=" + dealership + "&address=" + address + "&city=" + city + "&state=" + state + "&zip=" + zip + "&name=" + name + "&lname=" + lname + "&title=" + title + "&phone=" + phone + "&email=" + email + "&wholesale_phone=" + wholesale_phone + "&toll_free=" + toll_free + "&fax=" + fax + "&tmpp=" + tmpp + "&psx=" + psx + "&ops=" + ops + "&wsip=" + wsip + "&agree1=" + agree1 + "&agree2=" + agree2 + "&agree3=" + agree3 + "&program_option=" + program_option,
            success: function (text) {
              formSuccess();
              console.log(text);
            }
          });
        }

        function formSuccess() {
          $('.enroll-section').addClass("is_visible");
          $('#agree_modal').modal();
          $(".enroll-form").addClass('sent');
          $("#enroll-form")[0].reset();
          $(".modal-content").addClass('sent');
          $('.enroll-section').removeClass("is_visible");
          $(".modal-content").html("<h3>Congratulations! You’ve completed enrollment in the 2019 STAR Elite program. If additional action is required, the STAR Elite Admin or supplier partner will reach out to you within three business days.</h3>");
          submitMSG(true, "");
        }

        function formError() {
          console.log($('input[name=program]:checked').val());
          if ($('input[name=program]:checked').val() == undefined) {
            $(".programs-help-block").show();
          } else {
            $(".programs-help-block").hide();
          }

          $("#enroll-form").removeClass().addClass('enroll-form shake animated').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
            $(this).removeClass();
          });
        }

        function submitMSG(valid, msg) {
          if (valid) {
            var msgClasses = "text-left animated text-success";
            $("#form-submit").text("SENT");
          } else {
            var msgClasses = "text-left text-danger";
          }
          $("#msgSubmit").removeClass().addClass(msgClasses).text(msg);
        }


      }
    },
    'dealer_incentives': {
      init: function () {

        /*
                $('.resources-info').css({
                    display: 'inline-block',
                    "opacity": 1,
                    'min-height': "400px"
                }).append('<div class="load-box"><div class="loader"><div class="loader__figure"></div></div></div>');
                var json = null;

                function calendarFunc(termValue) {
                        //console.log(termValue);
                        if(termValue === "all") {
                            //console.log("clicked all");
                            termURL = relURL + "wp-json/wp/v2/dealer-api?filter[orderby]=date&order=asc&per_page=99";
                        } else if(termValue) {
                            termURL = relURL + "wp-json/wp/v2/dealer-api?filter[taxonomy]=incentives-category&filter[term]=" + termValue;
                        } else {
                            termURL = relURL + "wp-json/wp/v2/dealer-api?filter[orderby]=date&order=asc&per_page=99";
                        }
                        $.ajax({
                            //url: "data.json",
                            url: termURL,
                            cache: true,
                            type: "GET",
                            dataType: "json",
                            success: function (data) {
                                    json = data;
                                    //console.log(json);
                                    var cal_html = "<div class='row flexbox overlay-icons'>";
                                    var cat_desc = json[0].cat_desc.data.category_desc;
									cal_html += '<div class="intro-copy"><div class="col-xs-12 col-sm-12 col-md-9 section-title">'+ cat_desc +'</div></div>';

									for(var i = 0; i < json.length; i++) {
                                        var item = json[i];
                                        //console.log(item.id);
                                        var the_title = item.title.rendered,
                                            id = item.id,
                                            thumbnail_url = item.featured_img.data.featured_image_thumbnail_url,

											file_assets = item.meta_box,
                                            resource_subtitle = item.meta_box._sub_title,
                                            pdf_file = item.meta_box._pdf_assets,
                                            jpg_file = item.meta_box._img_assets,
                                            content = item.content.rendered,
                                            excerpt = item.excerpt.rendered,
                                            post_link = item.link;


										cal_html += '<div class="col-xs-12 col-sm-6 col-md-4 col fadein">' + '<div class="thumbnail">' + '<figure class="img-holder">';
                                        if($.isEmptyObject(jpg_file) && $.isEmptyObject(pdf_file)) {} else {
                                            cal_html += '<figcaption><a class="modal-view" data-id="' + id + '" href="#"> <span class="read-more"><span class="play-icon" data-id="' + id + '"><i class="material-icons">&#xE417;</i></span> </span></a></figcaption>';
                                        }
                                        cal_html += '<img src="' + thumbnail_url + '" class="img-responsive" alt="' + the_title + '" />' + '</a></figure>' + '<div class="desc-txt">' + '<h3>' + the_title + '<span>' + resource_subtitle + '</span></h3>' + content + '<ul class="downloads">';
                                        var obj;
                                        if($.isEmptyObject(jpg_file)) {
                                            for(prop in pdf_file) {
                                                obj = pdf_file[prop];
                                                //console.log (obj);
                                                var pdf_url = obj.url;
                                                cal_html += '<li><a data-id="' + id + '" class="modal-view" href="' + pdf_url + '"><i class="material-icons">&#xE417;</i>View ' + obj.title + '</a></li>' + '<li><a target="_blank" href="' + pdf_url + '" download><i class="material-icons">&#xE2C4;</i>Download ' + obj.title + '</a></li>';
                                            }
                                        } else {
                                            for(prop in jpg_file) {
                                                obj = jpg_file[prop];
                                                console.log(obj);
                                                var img_url = obj.full_url;
                                                cal_html += '<li><a target="_blank" data-id="' + id + '" class="modal-view" href="' + img_url + '"><i class="material-icons">&#xE417;</i>View ' + obj.title + '</a></li>' + '<li><a target="_blank" href="' + img_url + '" download><i class="material-icons">&#xE2C4;</i>Download ' + obj.title + '</a></li>';
                                            }
                                        } //e/o else
                                        cal_html += '</ul>' + '</div>' + '</div>' + '</div>';
                                        $('.resources-info').html(cal_html);
                                        // Scroll Reveal
                                    }
                                    //e/o loop
                                    cal_html += "</div>";
                                    //run modal func
                                    modalFunc();
                                }
                                //end success
                        });
                        //e/of load ajax request
                    }
                    //end calendarFunc
                    //init func
                    //calendarFunc();
                    //start ajax request
                    //check val on start
                function check() {
                    var termValue = $('.data-term').val();
                    calendarFunc(termValue);
                }
                check();
                $('.data-term').change(function () {
                    termValue = $(this).val();
                    //console.log(termValue);
                    calendarFunc(termValue);
                    //console.log(window.location.origin);
                    var path_origin = window.location.origin
                    window.history.pushState("", "", relURL + "incentives-category/" + termValue);
                });
                $(window).on('popstate', function (e) {
                    var state = e.originalEvent.state;
                    var urlState = window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1);
                    // console.log(urlState);
                    termValue = urlState;
                    calendarFunc(termValue);
                });
                */
        //modal view
        function modalFunc() {
          $('.modal-view').click(function (event) {
            event.preventDefault();
            //console.log(termValue);
            $('#view_modal').modal();
            //grab the data id
            var id = $(this).data('id');
            // console.log(id);
            //console.log(id);
            $('.modal-content').css({
              display: 'inline-block'
            }).animate({
              "opacity": 1,
              'min-height': "350px"
            }, 'slow').html('');
            //start ajax request
            var json = null;
            $.ajax({
              url: relURL + "wp-json/wp/v2/dealer-api?filter[orderby]=date&order=asc&per_page=99",
              type: "GET",
              data: {
                "id": id
              },
              cache: true,
              dataType: "json",
              success: function (data) {
                //console.log(id);
                //console.log(data);
                json = data;
                for (var i = 0, len = json.length; i < len; i++) {
                  // console.log(data[i].id);
                  if (json[i].id === id) {
                    console.log(data)
                    //console.log(json[i]['id']);
                    var src = json[i].featured_img.data.featured_image_thumbnail_url,
                      _id = json[i].id,
                      video_id = json[i].meta_box._video_id,
                      overlay_img = json[i].meta_box._img_assets,
                      pdf_overlay = json[i].meta_box._pdf_assets,
                      content = json[i].content.rendered,
                      title = json[i].title.rendered;
                    var pdf_url;
                    var src_url;
                    //overlay_img = json[i]['meta_box']['_gallery_images'];
                    for (var prop in overlay_img) {
                      src_url = overlay_img[prop].full_url;
                    }
                    var htmlData = '<div class="modal-header">' + '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' + '</div>' + '<div class="modal-body">';
                    if (src_url) {
                      htmlData += '<figure>' + '<img class="img-responsive" src="' + src_url + '" alt="' + title + '">' + '</figure>';
                    }
                    if (video_id) {
                      htmlData += '<div class="video_wrapper"><iframe id="player' + _id + '" src="https://player.vimeo.com/video/' + video_id + '?api=1&player_id=player' + _id + '&amp;autoplay=true" width="630" height="354" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>';
                    }
                    for (prop in pdf_overlay) {
                      pdf_url = pdf_overlay[prop].url;
                    }
                    if (pdf_url) {
                      htmlData += '<div><iframe src="' + pdf_url + '" style="width:100%; height:600px;" frameborder="0"></iframe></div>';
                    }
                    htmlData += '</div>' + '</div>';
                    $('.modal-content').html(htmlData);
                  }
                }
              }
            });
            //end ajax
          });
          //end click
          $('#view_modal').on('hidden.bs.modal', function () {
            $(".modal-content").empty();
          });
        }
        modalFunc();
        //e/o modal func
      }
    },
    'tax_product_category': {
      init: function () {
        UTIL.fire('products');
      }
    },
    'tax_incentives_category': {
      init: function () {
        UTIL.fire('dealer_incentives');
      }
    },
    'resources': {
      init: function () {
        console.log('resources updated');


        /*
            function registerSummernote(element, max, callbackMax) {
              $(element).summernote({
                tabsize: 2,
                height: 200,
                toolbar: [
                  ['font', ['bold', 'underline', 'italic', 'clear']],
                  ['color', ['color']],
                  ['para', ['paragraph']],
                  ['view', ['codeview']]
                ],
                callbacks: {
                  onKeydown: function (e) {
                    var t = e.currentTarget.innerText;
                    if (t.length >= max) {
                      //delete key
                      if (e.keyCode != 8)
                        e.preventDefault();
                      // add other keys ...
                    }
                  },
                  onKeyup: function (e) {
                    var t = e.currentTarget.innerText;
                    if (typeof callbackMax == 'function') {
                      callbackMax(max - t.length);
                    }
                  },
                  onPaste: function (e) {
                    var t = e.currentTarget.innerText;
                    var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                    e.preventDefault();
                    var all = t + bufferText;
                    document.execCommand('insertText', false, all.trim().substring(0, 404));
                    if (typeof callbackMax == 'function') {
                      callbackMax(max - t.length);
                    }
                  }
                }
              });
            }

            $(function () {
              registerSummernote('.promo-desc', 404, function (max) {
                $('.maxContentPost').text(max)
              });
            });
             */

        /*
        $('.promo-desc').summernote({
          tabsize: 2,
          height: 200,
          toolbar: [
            ['font', ['bold', 'underline', 'clear']],
            ['color', ['color']]
          ],

        });
        */

        function pdfFunc() {
          $('.part-type a').click(function (event) {
            event.preventDefault();
            var pdfTemplate = $(this).data('part'),
              partImg = $(this).data("img"),
              descCopy = $(this).data("copy");
            $('[data-desc]').html(descCopy);
            $('.pdf_part').val(pdfTemplate);
            $('.part-type a').removeClass("active");
            $(this).addClass("active");
            $('.pdf-bg img').attr('src', partImg);
            $('.btn-next').addClass("active").fadeIn(100).animate({
              'top': '-10px',
              'opacity': 1
            }, 500);
            $("html, body").stop(true, true).animate({
              scrollTop: $(".btn-next").offset().top
            }, 800);
            // $('.promo-desc').summernote('reset');
            //$('.promo-desc').summernote('insertText', descCopy);
            nextFunc();
          });
        }
        pdfFunc();

        function nextFunc() {
          $('.btn-next').click(function (event) {
            event.preventDefault();
            $(this).hide();
            $(".row-form").addClass("_activate");
            $(".part-row").hide();
            $("html, body").stop(true, true).animate({
              scrollTop: $(".row-form").offset().top
            }, 800);
          });
        }

        function backFunc() {
          $('.btn-back').click(function (event) {
            event.preventDefault();
            //$(this).hide();
            $('.btn-next').show();
            $(".row-form").removeClass("_activate");
            $(".part-row").show();
            $('html, body').animate({
              scrollTop: $(".part-row").offset().top
            }, 800);
          });
        }
        backFunc();
        // Function for Preview Image.
        $(function () {
          $(":file").change(function () {
            if (this.files && this.files[0]) {
              var reader = new FileReader();
              reader.onload = imageIsLoaded;
              reader.readAsDataURL(this.files[0]);
            }
          });
        });

        function imageIsLoaded(e) {
          $('#message').css("display", "none");
          $('#preview').css("display", "block");
          $('#alt_preview').css("display", "block");
          $('#previewimg').attr('src', e.target.result);
          $('.placeholder-logo').remove();

        };
        // Function for Deleting Preview Image.
        $("#deleteimg").click(function () {
          $('#preview').css("display", "none");
          $('#file').val("");
        });
        // Function for Displaying Details of Uploaded Image.
        $("#submit").click(function () {
          $('#preview').css("display", "none");
          $('#message').css("display", "block");

        });


        $('.pdf-form-fields input[type=text]').keyup(function (event) {
          //var dInput = this.value;
          //console.log(dInput);
          var title = $(this).data('name');
          console.log(title);
          var dInput = this.value;
          //console.log(dInput);
          $("[" + title + "]").html(dInput);
        });


        $('.pdf-form-fields textarea').keyup(function (event) {
          var desc = $(this).data('desc');
          var dtextarea = this.value;
          $("[" + desc + "]").html(dtextarea);
        });

        // summernote.change
        /*
        $('.promo-desc').on('summernote.change', function (we, contents, $editable) {
          console.log(contents);
          $("[data-desc]").html(contents);
        });
        */
        $("select.state-select").change(function () {
          var selectedState = $(this).children("option:selected").val();
          console.log(selectedState);
          $("[data-state]").html(selectedState);
        });

        console.log("yo yo");


        $("form.pdf-form-fields").on('submit', function (e) {
          e.preventDefault();
          var form = $(this);
          form.parsley().validate();
          if (form.parsley().isValid()) {
            submitForm();
            console.log("hello");
            var element = document.getElementById('element-to-print');
            // Generate the PDF.
            html2pdf().from(element).set({
              margin: [0.4, 1, 0.2, 1],
              filename: 'my_pdf_file.pdf',
              html2canvas: {
                scale: 2
              },
              image: {
                type: 'jpeg',
                quality: 1
              },
              jsPDF: {
                orientation: 'portrait',
                unit: 'in',
                format: 'letter',
                compressPDF: false
              }
            }).save();
          }
        });

        function submitForm() {
          var ajaxURL = MyAjax.ajaxurl;
          console.log(ajaxURL);
          // Initiate Variables With Form Content
          var pdf_offer = $("#promo-txt").val(),
            pdf_end_date = $("#promo-date").val(),
            pdf_dealership_name = $("#dealer-name").val(),
            pdf_address = $("#dealer-address").val(),
            pdf_city = $("#inputCity").val(),
            pdf_state = $("#inputState").val(),
            pdf_zip = $("#inputZip").val(),
            pdf_dealer_url = $("#dealer-url").val(),
            pdf_phone = $("#manager-phone").val(),
            pdf_first_name = $("#manager-name").val(),
            pdf_last_name = $("#manager-name").val(),
            pdf_email = $("#dealer-email").val(),
            pdf_product_name = $("#pdf-part").val();

          $.ajax({
            type: "POST",
            url: ajaxURL,
            data: {
              action: "pdfTool",
              pdf_offer: pdf_offer,
              pdf_product_name: pdf_product_name,
              pdf_end_date: pdf_end_date,
              pdf_dealership_name: pdf_dealership_name,
              pdf_address: pdf_address,
              pdf_city: pdf_city,
              pdf_state: pdf_state,
              pdf_zip: pdf_zip,
              pdf_dealer_url: pdf_dealer_url,
              pdf_phone: pdf_phone,
              pdf_first_name: pdf_first_name,
              pdf_last_name: pdf_last_name,
              pdf_email: pdf_email,
            },
            success: function (text) {
              console.log(text);
              $('.pdf-form-fields')[0].reset();
              if (text == "success") {

                formSuccess();

              } else {
                formError();
                submitMSG(false, text);
              }
            }
          });
        }

        function formSuccess() {
          $(".pdf_form").addClass('sent');

          console.log("hello");
          submitMSG(true, "");
        }


        function formError() {

        }

        function submitMSG(valid, msg) {
          if (valid) {
            var msgClasses = "text-left animated text-success";
            $("#pdf_form").text("SENT");
          } else {
            var msgClasses = "text-left text-danger";
          }
          $("#msgSubmit").removeClass().addClass(msgClasses).text(msg);
        }


        /*
       var stickySidebar = new StickySidebar('.pdf-card"', {
          topSpacing: 0,
          bottomSpacing: 20,
          resizeSensor: true,
          containerSelector: '.entry-content',
          innerWrapperSelector: '.sidebar__inner'
        });
        */


        //reset form fields on back click

        $(".btn-back").on("click", function () {
          //code here
          $('.pdf-form-fields')[0].reset();
          // $('.promo-desc').summernote('reset');

        });

        //end


        /*
                $('.resources-info').css({
                    display: 'inline-block'
                }).animate({
                    "opacity": 1,
                    'min-height': "350px"
                }, 'slow').html();
                var json = null;
                //e/o change request
                //term url - url: "/toyota/wp-json/wp/v2/calendar-api?filter[taxonomy]=calendar-category&filter[term]="+termValue,
                function calendarFunc(termValue) {
                        termURL = "";
                        console.log(termValue);
                        if(termValue === "all") {
                            //console.log("clicked all");
                            termURL = relURL + "wp-json/wp/v2/resource-api?filter[orderby]=date&order=asc&per_page=99";
                        } else if(termValue) {
                            termURL = relURL + "wp-json/wp/v2/resource-api?filter[taxonomy]=resource-category&filter[term]=" + termValue;
                        } else {
                            termURL = relURL + "wp-json/wp/v2/resource-api?filter[taxonomy]=resource-category&filter[term]=" + termValue;
                        }
                        $.ajax({
              //url: "data.json",
                            url: termURL,
                            cache: true,
                            type: "GET",
                            dataType: "json",
                            success: function (data) {
                                    json = data;
                                   // console.log(json);
                                    var cal_html = "<div class='row flexbox'>";
                                    var cat_desc = json[0].cat_desc.data.category_desc;
                  if (termValue === "all") {
                    //do nothing
                     } else {
                  cal_html += '<div class="intro-copy"><div class="col-xs-12 col-sm-12 col-md-9 section-title">'+ cat_desc +'</div></div>';
                     }

                  for(var i = 0; i < json.length; i++) {
                                        var item = json[i];
                                        //console.log(item.id);
                                        var the_title = item.title.rendered,
                                            id = item.id,
                                            thumbnail_url = item.featured_img.data.featured_image_thumbnail_url,
                                            show_modal = item.meta_box._show_modal,
                                            pdf_file = item.meta_box._pdf_assets,
                                            video_id = item.meta_box._video_id,
                                            jpg_file = item.meta_box._img_assets,
                                            content = item.content.rendered,
                                            post_link = item.link,
                                            ext_url = item.meta_box._url;
                                        cal_html += '<div class="col-xs-12 col-sm-6 col-md-3 col fadein overlay-icons">' + '<div class="thumbnail">' + '<figure class="img-holder">';
                                        if(video_id) {
                                            cal_html += '<figcaption><a class="modal-view vimeo-modal" data-id="' + id + '" href="#"> <span class="read-more"><span class="play-icon" data-id="' + id + '"><i class="material-icons">play_arrow</i></span> </span></a></figcaption>';
                                        }
                                        if($.isEmptyObject(jpg_file) && $.isEmptyObject(pdf_file)) {} else {
                                            cal_html += '<figcaption><a class="modal-view" data-id="' + id + '" href="#"> <span class="read-more"><span class="play-icon" data-id="' + id + '"><i class="material-icons">&#xE417;</i></span> </span></a></figcaption>';
                                        }
                                        cal_html += '<img src="' + thumbnail_url + '" class="img-responsive" alt="' + the_title + '" />' + '</figure>' + '<div class="desc-txt">' + '<h3>' + the_title + '</h3>' + '' + content + '' + '<ul class="downloads">';
                                        var obj;
                                        if(video_id) {
                                            cal_html += '<li><a data-id="' + id + '" class="modal-view" href="#"><i class="material-icons">play_circle_outline</i>Play Video</a></li>';
                                        }
                                        if(typeof pdf_file !== "undefined") {
                                            //if($.isEmptyObject(jpg_file)) {
                                            for(prop in pdf_file) {
                                                obj = pdf_file[prop];
                                                //console.log (obj);
                                                var pdf_url = obj.url;
                                                cal_html += '<li><a target="_blank" data-id="' + id + '" class="modal-view" href="' + pdf_url + '"><i class="material-icons">&#xE417;</i>View ' + obj.title + '</a></li>' + '<li><a target="_blank" href="' + pdf_url + '" download><i class="material-icons">&#xE2C4;</i>Download ' + obj.title + '</a></li>';
                                            }
                                        }
                                        if(typeof jpg_file !== "undefined") {
                                            for(prop in jpg_file) {
                                                obj = jpg_file[prop];
                                                //console.log(obj);
                                                var img_url = obj.full_url;
                                                cal_html += '<li><a target="_blank" data-id="' + id + '" class="modal-view" href="' + img_url + '"><i class="material-icons">&#xE417;</i>View ' + obj.title + '</a></li>' + '<li><a target="_blank" href="' + img_url + '" download><i class="material-icons">&#xE2C4;</i>Download ' + obj.title + '</a></li>';
                                            }
                                        } //e/o else
                                        cal_html += '</ul>' + '</div>' + '</div>' + '</div>';
                                        $('.resources-info').html(cal_html);
                                    }
                                    //e/o loop
                                    cal_html += "</div>";
                                    //run modal func
                                    modalFunc();
                                }
                                //end success
                        });
                        //e/of load ajax request
                    }
                    //end calendarFunc
                    //init func
                //calendarFunc();
                //start ajax request
                function check() {
                        var termValue = $('.data-term').val();
                        calendarFunc(termValue);
                    }
                    //check val on start
                check();
                $('.data-term').change(function () {
                    termValue = $(this).val();
                    //console.log(termValue);
                    calendarFunc(termValue);
                });

                */

        //modal view
        function modalFunc() {
          $('.modal-view').click(function (event) {
            event.preventDefault();
            //console.log(termValue);
            $('#view_modal').modal();
            //grab the data id
            var id = $(this).data('id');
            //console.log(id);
            $('#view_modal .modal-content').css({
              display: 'inline-block'
            }).animate({
              "opacity": 1,
              'min-height': "350px"
            }, 'slow').html('<div class="rectangle-bounce"><img class="loader" src="http://samherbert.net/svg-loaders/svg-loaders/circles.svg" /></div>');
            //start ajax request
            var json = null;
            $.ajax({
              url: relURL + "wp-json/wp/v2/resource-api?filter[orderby]=date&order=asc&per_page=99",
              type: "GET",
              timeout: 3000,
              data: {
                "id": id
              },
              cache: true,
              async: false,
              dataType: "json",
              success: function (data) {
                //console.log(id);
                //console.log(data);
                json = data;
                for (var i = 0, len = json.length; i < len; i++) {
                  // console.log(data[i].id);
                  if (json[i].id === id) {
                    //console.log(data)
                    //console.log(json[i]['id']);
                    var src = json[i].featured_img.data.featured_image_thumbnail_url,
                      _id = json[i].id,
                      video_id = json[i].meta_box._video_id,
                      overlay_img = json[i].meta_box._img_assets,
                      pdf_overlay = json[i].meta_box._pdf_assets,
                      content = json[i].content.rendered,
                      title = json[i].title.rendered;
                    var pdf_url;
                    var src_url;
                    //overlay_img = json[i]['meta_box']['_gallery_images'];
                    for (var prop in overlay_img) {
                      src_url = overlay_img[prop].full_url;
                    }
                    var htmlData = '<div class="modal-header">' + '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' + '</div>' + '<div class="modal-body">';
                    if (src_url) {
                      htmlData += '<figure>' + '<img class="img-responsive" src="' + src_url + '" alt="' + title + '">' + '</figure>';
                    }
                    if (video_id) {
                      htmlData += '<div class="video_wrapper"><iframe id="player' + _id + '" src="https://player.vimeo.com/video/' + video_id + '?api=1&player_id=player' + _id + '&amp;autoplay=true" width="630" height="354" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>';
                    }
                    for (prop in pdf_overlay) {
                      pdf_url = pdf_overlay[prop].url;
                    }
                    if (pdf_url) {
                      htmlData += '<div><iframe src="' + pdf_url + '" style="width:100%; height:600px;" frameborder="0"></iframe></div>';
                    }
                    htmlData += '</div>' + '</div>';
                    $('#view_modal .modal-content').html(htmlData);
                  }
                }
              }
            });
            //end ajax
          });
          //end click
          $('#view_modal').on('hidden.bs.modal', function () {
            $(".modal-content").empty();
          });
        }
        modalFunc();
        //e/o modal func
      }
    },


    'page_template_template_pdf': {
      init: function () {

        /*
            function registerSummernote(element, max, callbackMax) {
              $(element).summernote({
                tabsize: 2,
                height: 200,
                toolbar: [
                  ['font', ['bold', 'underline', 'italic', 'clear']],
                  ['color', ['color']],
                  ['para', ['paragraph']],
                  ['view', ['codeview']]
                ],
                callbacks: {
                  onKeydown: function (e) {
                    var t = e.currentTarget.innerText;
                    if (t.length >= max) {
                      //delete key
                      if (e.keyCode != 8)
                        e.preventDefault();
                      // add other keys ...
                    }
                  },
                  onKeyup: function (e) {
                    var t = e.currentTarget.innerText;
                    if (typeof callbackMax == 'function') {
                      callbackMax(max - t.length);
                    }
                  },
                  onPaste: function (e) {
                    var t = e.currentTarget.innerText;
                    var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                    e.preventDefault();
                    var all = t + bufferText;
                    document.execCommand('insertText', false, all.trim().substring(0, 404));
                    if (typeof callbackMax == 'function') {
                      callbackMax(max - t.length);
                    }
                  }
                }
              });
            }

            $(function () {
              registerSummernote('.promo-desc', 404, function (max) {
                $('.maxContentPost').text(max)
              });
            });
             */

        /*
        $('.promo-desc').summernote({
          tabsize: 2,
          height: 200,
          toolbar: [
            ['font', ['bold', 'underline', 'clear']],
            ['color', ['color']]
          ],

        });
        */

        function pdfFunc() {
          $('.part-type a').click(function (event) {
            event.preventDefault();
            var pdfTemplate = $(this).data('part'),
              partImg = $(this).data("img"),
              descCopy = $(this).data("copy");
            $('[data-desc]').html(descCopy);
            $('.pdf_part').val(pdfTemplate);
            $('.part-type a').removeClass("active");
            $(this).addClass("active");
            $('.pdf-bg img').attr('src', partImg);
            $('.btn-next').addClass("active").fadeIn(100).animate({
              'top': '-10px',
              'opacity': 1
            }, 500);
            $("html, body").stop(true, true).animate({
              scrollTop: $(".row-form").offset().top
            }, 800);
            // $('.promo-desc').summernote('reset');
            //$('.promo-desc').summernote('insertText', descCopy);
            nextFunc();
          });
        }
        pdfFunc();

        function nextFunc() {
          $('.btn-next').click(function (event) {
            event.preventDefault();
            $(this).hide();
            $(".row-form").addClass("_activate");
            $(".part-row").hide();
            $("html, body").stop(true, true).animate({
              scrollTop: $(".row-form").offset().top
            }, 800);
          });
        }

        function backFunc() {
          $('.btn-back').click(function (event) {
            event.preventDefault();
            //$(this).hide();
            $('.btn-next').show();
            $(".row-form").removeClass("_activate");
            $(".part-row").show();
            $('html, body').animate({
              scrollTop: $(".part-row").offset().top
            }, 800);
          });
        }
        backFunc();
        // Function for Preview Image.
        $(function () {
          $(":file").change(function () {
            if (this.files && this.files[0]) {
              var reader = new FileReader();
              reader.onload = imageIsLoaded;
              reader.readAsDataURL(this.files[0]);
            }
          });
        });

        function imageIsLoaded(e) {
          $('#message').css("display", "none");
          $('#preview').css("display", "block");
          $('#alt_preview').css("display", "block");
          $('#previewimg').attr('src', e.target.result);
          $('.placeholder-logo').remove();

        };
        // Function for Deleting Preview Image.
        $("#deleteimg").click(function () {
          $('#preview').css("display", "none");
          $('#file').val("");
        });
        // Function for Displaying Details of Uploaded Image.
        $("#submit").click(function () {
          $('#preview').css("display", "none");
          $('#message').css("display", "block");

        });


        $('.pdf-form-fields input[type=text]').keyup(function (event) {
          //var dInput = this.value;
          //console.log(dInput);
          var title = $(this).data('name');
          console.log(title);
          var dInput = this.value;
          //console.log(dInput);
          $("[" + title + "]").html(dInput);
        });


        $('.pdf-form-fields textarea').keyup(function (event) {
          var desc = $(this).data('desc');
          var dtextarea = this.value;
          $("[" + desc + "]").html(dtextarea);
        });

        // summernote.change
        /*
        $('.promo-desc').on('summernote.change', function (we, contents, $editable) {
          console.log(contents);
          $("[data-desc]").html(contents);
        });
        */
        $("select.state-select").change(function () {
          var selectedState = $(this).children("option:selected").val();
          console.log(selectedState);
          $("[data-state]").html(selectedState);
        });


        $("form.pdf-form-fields").on('submit', function (e) {
          e.preventDefault();
          var form = $(this);
          form.parsley().validate();
          if (form.parsley().isValid()) {
            submitForm();
            var element = document.getElementById('element-to-print');
            // Generate the PDF.
            html2pdf().from(element).set({
              margin: [0.4, 1, 0.2, 1],
              filename: 'my_pdf_file.pdf',
              html2canvas: {
                scale: 2
              },
              image: {
                type: 'jpeg',
                quality: 1
              },
              jsPDF: {
                orientation: 'portrait',
                unit: 'in',
                format: 'letter',
                compressPDF: false
              }
            }).save();
          }
        });

        function submitForm() {
          var ajaxURL = MyAjax.ajaxurl;
          // Initiate Variables With Form Content
          var pdf_offer = $("#promo-txt").val(),
            pdf_end_date = $("#promo-date").val(),
            pdf_dealership_name = $("#dealer-name").val(),
            pdf_address = $("#dealer-address").val(),
            pdf_city = $("#inputCity").val(),
            pdf_state = $("#inputState").val(),
            pdf_zip = $("#inputZip").val(),
            pdf_dealer_url = $("#dealer-url").val(),
            pdf_phone = $("#manager-phone").val(),
            pdf_first_name = $("#manager-name").val(),
            pdf_last_name = $("#manager-name").val(),
            pdf_email = $("#dealer-email").val(),
            pdf_product_name = $("#pdf-part").val();

          $.ajax({
            type: "POST",
            url: ajaxURL,
            data: {
              action: "pdfTool",
              pdf_offer: pdf_offer,
              pdf_product_name: pdf_product_name,
              pdf_end_date: pdf_end_date,
              pdf_dealership_name: pdf_dealership_name,
              pdf_address: pdf_address,
              pdf_city: pdf_city,
              pdf_state: pdf_state,
              pdf_zip: pdf_zip,
              pdf_dealer_url: pdf_dealer_url,
              pdf_phone: pdf_phone,
              pdf_first_name: pdf_first_name,
              pdf_last_name: pdf_last_name,
              pdf_email: pdf_email,
            },
            success: function (text) {
              $('.pdf-form-fields')[0].reset();
              if (text == "success") {

                formSuccess();

              } else {
                formError();
                submitMSG(false, text);
              }
            }
          });
        }

        function formSuccess() {
          $(".pdf_form").addClass('sent');


          submitMSG(true, "");
        }


        function formError() {

        }

        function submitMSG(valid, msg) {
          if (valid) {
            var msgClasses = "text-left animated text-success";
            $("#pdf_form").text("SENT");
          } else {
            var msgClasses = "text-left text-danger";
          }
          $("#msgSubmit").removeClass().addClass(msgClasses).text(msg);
        }


        /*
       var stickySidebar = new StickySidebar('.pdf-card"', {
          topSpacing: 0,
          bottomSpacing: 20,
          resizeSensor: true,
          containerSelector: '.entry-content',
          innerWrapperSelector: '.sidebar__inner'
        });
        */


        //reset form fields on back click

        $(".btn-back").on("click", function () {
          //code here
          $('.pdf-form-fields')[0].reset();
          // $('.promo-desc').summernote('reset');

        });

        //end

      }
    },
    'page_template_template_pdf_report': {
      init: function () {

        // oTable.draw();

        $(function () {
          var oTable = $('#dataTable').DataTable({
            dom: 'Bfrtip',
            //scrollY:        '50vh',
            order: [
              [0, "desc"]
            ],
            scrollCollapse: true,
            paging: true,
            "pageLength": 100,
            responsive: true,
            buttons: [
              'csv', 'excel'
            ],
          });

          $('#datepicker_from')
            .datepicker({
              //showOn: 'button',
              buttonImage: 'images/calendar.gif',
              buttonImageOnly: false,
              onSelect: function (date) {
                minDateFilter = new Date(date).getTime();
                oTable.draw();
              },
            })
            .keyup(function () {
              minDateFilter = new Date(this.value).getTime();
              oTable.draw();
            });

            
          $('#datepicker_to')
            .datepicker({
              //showOn: 'button',
              buttonImage: 'images/calendar.gif',
              buttonImageOnly: false,
              onSelect: function (date) {
                maxDateFilter = new Date(date).getTime();
                oTable.draw();
              },
            })
            .keyup(function () {
              maxDateFilter = new Date(this.value).getTime();
              oTable.draw();
            });
        });

        // Date range filter
        minDateFilter = '';
        maxDateFilter = '';

        $.fn.dataTableExt.afnFiltering.push(function (oSettings, aData, iDataIndex) {
          if (typeof aData._date == 'undefined') {
            aData._date = new Date(aData[0]).getTime();
          }

          if (minDateFilter && !isNaN(minDateFilter)) {
            if (aData._date < minDateFilter) {
              return false;
            }
          }

          if (maxDateFilter && !isNaN(maxDateFilter)) {
            if (aData._date > maxDateFilter) {
              return false;
            }
          }

          return true;
        });

        $('.clearDates').on('click', function () {
          var $dates = $('#datepicker_from, #datepicker_to').datepicker();
          $dates.datepicker('setDate', null);
          oTable.draw();
        });


      }
    },

    'products': {
      init: function () {
        console.log('products');
        //modal view
        function modalFunc() {
          $('.modal-view').click(function (event) {
            event.preventDefault();
            //console.log(termValue);
            $('#view_modal').modal();
            //grab the data id
            var id = $(this).data('id');
            console.log(id);
            //console.log(id);
            $('.modal-content').css({
              display: 'inline-block'
            }).animate({
              "opacity": 1,
              'min-height': "350px"
            }, 'slow').html('<div class="rectangle-bounce"><img class="loader" src="http://samherbert.net/svg-loaders/svg-loaders/circles.svg" /></div>');
            //start ajax request
            var json = null;
            $.ajax({
              url: relURL + "wp-json/wp/v2/product-api?filter[orderby]=date&order=asc&per_page=99",
              type: "GET",
              data: {
                "id": id
              },
              cache: true,
              dataType: "json",
              success: function (data) {
                //console.log(id);
                //console.log(data);
                json = data;
                for (var i = 0, len = json.length; i < len; i++) {
                  // console.log(data[i].id);
                  if (json[i].id === id) {
                    //console.log(data)
                    //console.log(json[i]['id']);
                    var src = json[i].featured_img.data.featured_image_thumbnail_url,
                      _id = json[i].id,
                      video_id = json[i].meta_box._video_id,
                      overlay_img = json[i].meta_box._img_assets,
                      pdf_overlay = json[i].meta_box._pdf_assets,
                      content = json[i].content.rendered,
                      title = json[i].title.rendered;
                    var src_url,
                      pdf_url;
                    //overlay_img = json[i]['meta_box']['_gallery_images'];
                    for (prop in overlay_img) {
                      src_url = overlay_img[prop].full_url;
                    }
                    var htmlData = '<div class="modal-header">' + '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' + '</div>' + '<div class="modal-body">';
                    if (src_url) {
                      htmlData += '<figure>' + '<img class="img-responsive" src="' + src_url + '" alt="' + title + '">' + '</figure>';
                    }
                    if (video_id) {
                      htmlData += '<div class="video_wrapper"><iframe id="player' + _id + '" src="https://player.vimeo.com/video/' + video_id + '?api=1&player_id=player' + _id + '&amp;autoplay=true" width="630" height="354" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div><div><button>Play</button><button>Pause</button><p>Status: <span class="status">&hellip;</span></p></div>';
                    }
                    for (prop in pdf_overlay) {
                      pdf_url = pdf_overlay[prop].url;
                    }
                    if (pdf_url) {
                      htmlData += '<div><iframe src="' + pdf_url + '" style="width:100%; height:600px;" frameborder="0"></iframe></div>';
                    }
                    htmlData += '</div>' + '</div>';
                    $('.modal-content').html(htmlData);
                  }
                }
              }
            });
            //end ajax
          });
          //end click
          $('#view_modal').on('hidden.bs.modal', function () {
            $(".modal-content").empty();
          });
        }
        modalFunc();


        /*
          $('.resources-info').css({
              display: 'inline-block'
          }).animate({
              "opacity": 1,
              'min-height': "350px"
          }, 'slow').html();

          var json = null;
          //e/o change request
          //term url - url: "/wp-json/wp/v2/calendar-api?filter[taxonomy]=calendar-category&filter[term]="+termValue,
          function calendarFunc(termValue) {
                  termURL = "";
                  //console.log(termValue);
                  if(termValue === "all") {
                      console.log("clicked all");
                    termURL = relURL + "wp-json/wp/v2/product-api?filter[orderby]=date&order=asc&per_page=99";
                  } else if(termValue) {
                    console.log("clicked " + termValue);
                    termURL = relURL + "wp-json/wp/v2/product-api?filter[taxonomy]=product-category&filter[term]=" + termValue;
                    console.log(termURL);
                  } else {
                    termURL = relURL + "wp-json/wp/v2/product-api?filter[orderby]=date&order=asc&per_page=99";
                  }
                  $.ajax({
                      //url: "data.json",
                      url: termURL,
                      cache: true,
                      type: "GET",
                      dataType: "json",
                      success: function (data) {

                        console.log('successs');

                            json = data;
                            //console.log(json[0].cat_desc.data.category_desc);
                            //
                            var cal_html = "<div class='row flexbox overlay-icons'>";
                            var cat_desc = json[0].cat_desc.data.category_desc;
                            cal_html += '<div class="intro-copy"><div class="col-xs-12 col-sm-12 col-md-9 section-title">'+ cat_desc +'</div></div>';
                            for(var i = 0; i < json.length; i++) {

                              var item = json[i];
                              //console.log(item.id);
                              var the_title = item.title.rendered,
                                  id = item.id,
                                  thumbnail_url = item.featured_img.data.featured_image_thumbnail_url,

                                  file_assets = item.meta_box,
                                  pdf_file = item.meta_box._pdf_assets,
                                  jpg_file = item.meta_box._img_assets,
                                  content = item.content.rendered,
                                  excerpt = item.excerpt.rendered,
                                  post_link = item.link;

                                //console.log(cat_desc);
                                cal_html += '<div class="col-xs-12 col-sm-6 col-md-4 col fadein ">' + '<div class="thumbnail">' + '<figure class="img-holder">';
                                  if($.isEmptyObject(jpg_file) && $.isEmptyObject(pdf_file)) {} else {
                                    cal_html += '<figcaption><a class="modal-view" data-id="' + id + '" href="#"> <span class="read-more"><span class="play-icon" data-id="' + id + '"><i class="material-icons">&#xE417;</i></span> </span></a></figcaption>';
                                  }
                                  cal_html += '<img src="' + thumbnail_url + '" class="img-responsive" alt="' + the_title + '" />' + '</figure>' + '<div class="desc-txt">' + '<h3>' + the_title + '</h3>' + content + '<ul class="downloads">';
                                  var obj;
                                  if($.isEmptyObject(jpg_file)) {
                                     // console.log("this is empty");
                                      for(prop in pdf_file) {
                                          obj = pdf_file[prop];
                                          //console.log (obj);
                                          var pdf_url = obj.url;
                                          cal_html += '<li><a target="_blank" data-id="' + id + '" class="pdf-view" href="' + pdf_url + '"><i class="material-icons">&#xE417;</i>View ' + obj.title + '</a></li>' + '<li><a target="_blank" href="' + pdf_url + '" download><i class="material-icons">&#xE2C4;</i>Download ' + obj.title + '</a></li>';
                                      }
                                  } else {
                                      for(prop in jpg_file) {
                                          obj = jpg_file[prop];
                                         // console.log(obj);
                                          var img_url = obj.full_url;
                                          cal_html += '<li><a target="_blank" data-id="' + id + '" class="modal-view" href="' + img_url + '"><i class="material-icons">&#xE417;</i>View ' + obj.title + '</a></li>' + '<li><a target="_blank" href="' + img_url + '" download><i class="material-icons">&#xE2C4;</i>Download ' + obj.title + '</a></li>';
                                      }
                                  } //e/o else
                                  cal_html += '</ul>' + '</div>' + '</div>' + '</div>';
                                  $('.resources-info').html(cal_html);
                                  // console.log('okaaayyyy');
                                  // Scroll Reveal
                              }
                              //e/o loop
                              cal_html += "</div>";
                              //run modal func
                              modalFunc();
                          }
                  });
              }

              function check() {
                var termValue = $('.data-term').val();
                calendarFunc(termValue);
                // console.log(termValue);
                console.log('Part 2');
              }

              check();

              $('.data-term').change(function () {
                termValue = $(this).val();
                //console.log(termValue);
                calendarFunc(termValue);
              });
              */

        //e/o modal func
      }
    }
  };
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';
      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');
      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });
      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };
  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
